import React from "react";

import { Provider } from "react-redux";

import App from "./App";

//NOTE(villep): Fixes issue with VS complaining about missing properties, when they are provided by redux

// tslint:disable-next-line:no-any
const Component: any = App;

// tslint:disable-next-line:no-any
const Root = ({ store }: any) => {
    return (
        <Provider store={store}>
            <Component />
        </Provider>
    );
};

export default Root;



// WEBPACK FOOTER //
// ./src/Root.tsx